import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '../../translate/translate.module';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-warning-notice',
  templateUrl: './warning-notice.component.html',
  styleUrls: ['./warning-notice.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule]
})
export class WarningNoticeComponent {
  @Input() text: string = '';
  @Input() variant: 'warning' | 'error' = 'warning';
  @Input() actionLabel: string = '';
  @Input() busy = false;
  @Output() action = new EventEmitter<void>();
}
